import React, { useState } from 'react';
import './DatePicker.css';
import Map from './map.js';

export default function DatePicker({ handleApplyClick, isMapLoaded }) {
    
  console.log(typeof handleApplyClick);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  return (
    <div className="date-picker-container">
      <label>Start Date:</label>
      <input type="date" value={startDate} onChange={handleStartDateChange} />

      <label>End Date:</label>
      <input type="date" value={endDate} onChange={handleEndDateChange} />

      <button onClick={() => { handleApplyClick(startDate, endDate); }} disabled={!isMapLoaded}>Apply</button>
    </div>
  );
}
